import clsx from 'clsx';
import React from 'react';
import styles from './ClockDigit.module.scss';

export const ClockDigit = (
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) => <div {...props} className={clsx(styles.root, props.className)} />;
